import { render, staticRenderFns } from "./AddCandidatesToJob.vue?vue&type=template&id=56ba57a9&"
import script from "./AddCandidatesToJob.vue?vue&type=script&lang=js&"
export * from "./AddCandidatesToJob.vue?vue&type=script&lang=js&"
import style0 from "./AddCandidatesToJob.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports